const cards = [
  {
    title: '每周必看·高分电影推荐',
    desc: '编辑精选本周最值得观看的10部高分电影，4K蓝光画质搭配深度影评解读，让你不错过任何一部好片。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20collection%20display%20with%20golden%20movie%20awards%20trophies%20and%20elegant%20lighting%2C%20luxury%20cinema%20aesthetic%2C%20warm%20tones%2C%20professional%20product%20photography%2C%20no%20text%2C%20sophisticated&width=800&height=500&seq=card-01-mv&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '暑期档·大片连播季',
    desc: '暑期热门大片持续更新中！动作、科幻、动画全类型覆盖，暑假在家也能享受影院级的观影快感。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20movie%20night%20vibe%20with%20popcorn%20and%20home%20theater%20setup%2C%20cozy%20living%20room%20with%20warm%20lighting%2C%20cinematic%20atmosphere%2C%20no%20text%2C%20inviting%20and%20comfortable&width=800&height=500&seq=card-02-mv&orientation=landscape',
    tag: '暑期专场',
  },
  {
    title: '新用户观影指南',
    desc: '第一次来蘑菇影视？这份指南帮你快速上手：如何按画质筛选、按类型浏览、发现隐藏的高分冷门佳片。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20with%20laptop%20displaying%20streaming%20interface%2C%20warm%20ambient%20lighting%2C%20clean%20workspace%2C%20professional%20setup%2C%20no%20text%2C%20sleek%20and%20modern&width=800&height=500&seq=card-03-mv&orientation=landscape',
    tag: '新手指南',
  },
  {
    title: '冷门佳片·被低估的宝藏',
    desc: '发掘那些评分高却鲜为人知的遗珠之作，悬疑、文艺、独立电影，每一部都是等待被发现的惊喜。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20light%20in%20dim%20room%2C%20nostalgic%20cinema%20atmosphere%2C%20artistic%20composition%2C%20no%20text%2C%20moody%20and%20atmospheric&width=800&height=500&seq=card-04-mv&orientation=landscape',
    tag: '宝藏推荐',
  },
  {
    title: '追剧日历·每日更新提醒',
    desc: '热门剧集更新日程一表掌握，追剧不再错过任何一集。韩剧、国产剧、美剧同步追踪，让追剧更有计划。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20calendar%20and%20schedule%20planner%20with%20cinematic%20aesthetic%2C%20warm%20lighting%2C%20organized%20desk%20setup%2C%20professional%20photography%2C%20no%20text%2C%20clean%20and%20minimal&width=800&height=500&seq=card-05-mv&orientation=landscape',
    tag: '追剧必备',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精选推荐</h2>
          <p className="mt-3 text-sm text-foreground-500">精心编排的影视专题与观影指南</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, i) => (
            <div
              key={i}
              className={`bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer group ${
                i >= 3 ? 'lg:col-span-1' : ''
              } ${i === 3 ? 'sm:col-span-2 lg:col-span-1' : ''} ${i === 4 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[11px] font-medium bg-primary-500 text-white rounded-md whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}